<div class="dialog-header">
  <h2>Edit plan start date</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Active Date</label>
    <input
      type="date"
      [(ngModel)]="form.activeDate"
      (ngModelChange)="calcExpiration()"
    />
  </div>

  <div class="form-group">
    <label>New Expiration Date</label>
    <input
      type="text"
      [value]="form.newExpirationDate"
      class="readonly-input"
      readonly
    />
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
